import React, { useState, useRef } from 'react';
import {
  Box,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { NavigateBefore, NavigateNext, SwipeLeftTwoTone, SwipeRightTwoTone } from '@mui/icons-material';
import Carousel from 'react-material-ui-carousel';
import styles from './styles';
import FeaturesCard from '../../ui/hydraulics/FeaturesCard';
import { HYDRAULICS_LANDING_FEATURES } from '../../../utils/constants';
import { isMobile } from 'react-device-detect';

const Features = () => {
  const classes = styles();
  const scrollContainerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const cardsPerPage = 4;
  const totalPages = Math.ceil(HYDRAULICS_LANDING_FEATURES.length / cardsPerPage);

  const scrollLeft = () => {
    const container = scrollContainerRef.current;

    if (container) {
      container.scrollTo({
        left: container.scrollLeft - (container.clientWidth * 0.8),
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    const container = scrollContainerRef.current;

    if (container) {
      container.scrollTo({
        left: container.scrollLeft + (container.clientWidth * 0.8),
        behavior: 'smooth',
      });
    }
  };

  return (
    <Box className={classes.featuresWrapper}>
      <Box className={classes.featuresContainer}>
        <Typography variant='h3' className={classes.featuresSubtitle}>MPD-Focused Drilling Hydraulics</Typography>
      </Box>
      {isMobile
        ? (
        <>
          <IconButton
            disableRipple
            disableFocusRipple
            onClick={scrollLeft}
            className={classes.mobileActionIcon}
            sx={{
              transform: 'translateX(-50px)',
              p: 1
            }}
          >
            <SwipeLeftTwoTone sx={{ fontSize: 40 }} />
          </IconButton>
          <IconButton
            disableRipple
            disableFocusRipple
            onClick={scrollRight}
            className={classes.mobileActionIcon}
            sx={{
              transform: 'translateX(50px)',
              p: 1
            }}
          >
            <SwipeRightTwoTone sx={{ fontSize: 40 }} />
          </IconButton>
          <Grid className={classes.featuresMobileWrapper} ref={scrollContainerRef}>
            {HYDRAULICS_LANDING_FEATURES.map((item) => {
              return (
                <Box key={`feature-${item?.id}`} className={classes.featuresMobileCardWrapper}>
                    <FeaturesCard
                      image={item?.image}
                      label={item?.label}
                      reduceSize={item?.reduceSize}
                    />
                </Box>
              );
            })}
          </Grid>
        </>
          )
        : (
        <Carousel
        swipe={false}
        autoPlay={true}
        NextIcon={<NavigateNext />}
        PrevIcon={<NavigateBefore />}
        className={classes.carousel}
        index={currentIndex}
        onChange={(index) => setCurrentIndex(index)}
        navButtonsWrapperProps={{
          style: {
            display: 'none',
          }
        }}
        indicatorContainerProps={{
          style: {
            zIndex: 1,
            marginTop: '20px',
          }
        }}
      >
        {Array.from({ length: totalPages }).map((_, pageIndex) => (
          <Box
            key={pageIndex}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            padding="0"
          >
            <IconButton
              disableRipple
              onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
              disabled={currentIndex === 0}
              className={classes.actionIcon}
            >
              <NavigateBefore sx={{ fontSize: '50px' }} />
            </IconButton>
            <Grid container justifyContent="flex-start" sx={{ m: 0, flexWrap: 'nowrap', gap: '10px' }}>
              {HYDRAULICS_LANDING_FEATURES.slice(pageIndex * cardsPerPage, pageIndex * cardsPerPage + cardsPerPage).map((item) => {
                return (
                  <FeaturesCard
                    key={`feature-${item?.id}`}
                    image={item?.image}
                    label={item?.label}
                    reduceSize={item?.reduceSize}
                  />
                );
              })}
            </Grid>
            <IconButton
              disableRipple
              onClick={() => setCurrentIndex(Math.min(totalPages - 1, currentIndex + 1))}
              disabled={currentIndex === totalPages - 1}
              className={classes.actionIcon}
            >
              <NavigateNext sx={{ fontSize: '50px' }} />
            </IconButton>
          </Box>
        ))}
      </Carousel>
          )}
    </Box>
  );
};

export default Features;
